export const 
    amex = require('./amex.svg'),
    discover = require('./discover.svg'),
    mastercard = require('./mastercard.svg'),
    visa = require('./visa.svg')